import { render } from "./localizedTinymce.vue?vue&type=template&id=61f8a621&scoped=true&ts=true"
import script from "./localizedTinymce.vue?vue&type=script&lang=ts"
export * from "./localizedTinymce.vue?vue&type=script&lang=ts"

import "./localizedTinymce.vue?vue&type=style&index=0&id=61f8a621&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f8a621"]])

export default __exports__